// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mud-panel .content {
  padding: 1.25rem 1.5rem;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  margin-top: 1rem;
}
.mud-panel .field-label {
  display: block;
  font-size: 0.8rem;
  margin-bottom: 2px;
  color: #424242;
}
.mud-panel .readonly-field {
  background-color: #eeeeee;
  color: #424242;
}
.mud-panel .col-md-2-4 {
  flex: 0 0 auto;
  width: 20%;
}
.mud-panel .additives-table {
  table-layout: fixed;
  width: 100%;
}
.mud-panel .additives-table th:first-child,
.mud-panel .additives-table td:first-child {
  width: 42px;
}
.mud-panel .additives-table thead th {
  background-color: #0066b2;
  color: #fff;
  font-weight: 500;
  font-size: 0.85rem;
}
.mud-panel .additives-table td, .mud-panel .additives-table th {
  vertical-align: middle;
}
.mud-panel .additives-table .readonly-cell {
  color: #424242;
}
.mud-panel .additives-table .totals-row {
  background-color: #f5f5f5;
}
.mud-panel .btn-remove {
  border: none;
  background: transparent;
  color: #d32f2f;
  line-height: 0;
  padding: 0;
}
.mud-panel .btn-remove mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.mud-panel .red-label {
  color: var(--mat-form-field-error-text-color, #f44336);
  font-size: 0.85em;
}
.mud-panel .btn-spinner {
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/mud-formulation/mud-formulation.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGE;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAHJ;AAME;EACE,yBAAA;EACA,cAAA;AAJJ;AAOE;EACE,cAAA;EACA,UAAA;AALJ;AAQE;EACE,mBAAA;EACA,WAAA;AANJ;AAQI;;EAEE,WAAA;AANN;AASI;EACE,yBCpCQ;EDqCR,WAAA;EACA,gBAAA;EACA,kBAAA;AAPN;AAUI;EACE,sBAAA;AARN;AAWI;EACE,cAAA;AATN;AAYI;EACE,yBAAA;AAVN;AAcE;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;AAZJ;AAcI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAZN;AAgBE;EACE,sDAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AAfJ","sourcesContent":["@use '../../../../../styles/colors' as colors;\n\n.mud-panel {\n  .content {\n    padding: 1.25rem 1.5rem;\n    border: 1px solid #dcdcdc;\n    border-radius: 8px;\n    margin-top: 1rem;\n  }\n\n  .field-label {\n    display: block;\n    font-size: 0.8rem;\n    margin-bottom: 2px;\n    color: #424242;\n  }\n\n  .readonly-field {\n    background-color: #eeeeee;\n    color: #424242;\n  }\n\n  .col-md-2-4 {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .additives-table {\n    table-layout: fixed;\n    width: 100%;\n\n    th:first-child,\n    td:first-child {\n      width: 42px;\n    }\n\n    thead th {\n      background-color: colors.$medium-blue;\n      color: #fff;\n      font-weight: 500;\n      font-size: 0.85rem;\n    }\n\n    td, th {\n      vertical-align: middle;\n    }\n\n    .readonly-cell {\n      color: #424242;\n    }\n\n    .totals-row {\n      background-color: #f5f5f5;\n    }\n  }\n\n  .btn-remove {\n    border: none;\n    background: transparent;\n    color: #d32f2f;\n    line-height: 0;\n    padding: 0;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .red-label {\n    color: var(--mat-form-field-error-text-color, #f44336);\n    font-size: 0.85em;\n  }\n\n  .btn-spinner {\n    display: inline-block;\n    margin-right: 6px;\n    vertical-align: middle;\n  }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
